<template>
    <div >
   <div ref="mapOption2" class="line2" id="line2"></div>
   </div>
  </template>
  
  <script>
  import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
  import Pagination from 'components/pagination';
  // 引入 echarts 核心模块，核心模块提供了 echarts 使用必须要的接口。
  // import * as echarts from 'echarts/core';
  // 引入柱状图图表，图表后缀都为 Chart
  // import { BarChart } from 'echarts/charts';
  
  export default {
    name: 'reportList',
    props:['datas','start','end','symbol','type'],
    computed: {
    ...mapState('report',['echartsData'])
    },
    components: {
      Pagination
    },
    mounted () {

    this.showChart2()
  
    },
    watch: {
      start:{
        handler(val,oldVal){
            if(val){
                this.getTurnover({
                    endTime: this.end ,
                    startTime: val,
                    symbol: this.symbol,
                    type: this.type
                }).then(res=>{
                    console.log('start-res',res);
                    this.showChart2(res)
                })
            }
        }
      }  ,
    //   end:{
    //     handler(val,oldVal){
    //         console.log('val-end',val);
    //         console.log('oldVal-end',oldVal);
    //         if(val){
    //             this.getTurnover({
    //                 endTime: val ,
    //                 startTime: this.start,
    //                 symbol: this.symbol,
    //                 type: this.type
    //             }).then(res=>{
    //                 console.log('end-res',res);
    //                 this.showChart2(res)
    //             })
    //         }
    //     }
    //   },  
      symbol:{
        handler(val,oldVal){
            if(val!=oldVal){
                this.getTurnover({
                    endTime: this.end ,
                    startTime: this.start,
                    symbol: val,
                    type: this.type
                }).then(res=>{
                    this.showChart2(res)
                })
            }
        }
      }  
    },
    methods: {
        ...mapActions('report',['getTurnover']),
    async  showChart2() {

              // (1)初始化echarts
              const mychart = this.$echarts.init(this.$refs.mapOption2);
              const option = {
                        color: ['#80FFA5', '#00DDFF', '#37A2FF', '#FF0087', '#FFBF00'],
                        title: {
                        // text: '交易人数 \n 总人数'
                        },
                        tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross',
                            label: {
                            backgroundColor: '#37A2FF'
                            }
                        }
                        },
                        legend: {
                        data: ['交易额'],
                        // left:'auto',
                        top:20
                        },
                        toolbox: {
                        feature: {
                            saveAsImage: {}
                        }
                        },
                        grid: {
                        left: '2%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                        },
                        xAxis: [
                        {
                            type: 'category',
                            boundaryGap: false,
                            // data: this.echartsData.avgAmountList.map(item=>{return ''}),
                            data: this.echartsData.avgAmountList.map(item=>{return ''}),
                            "axisLine":{"show":false},//隐藏x轴线
                            "axisTick":{"show":false},//隐藏x轴刻度
                        }
                        ],
                        yAxis: [
                        {
                            show: false,
                            type: 'value',
                            // name:''
                            "axisLine":{"show":false},//隐藏Y轴线
                            "aYisTick":{"show":false},//隐藏Y轴刻度
                        }
                        ],
                        series: [
                        {
                            name: '交易额',
                            type: 'line',
                            stack: 'Total',
                            smooth: true,
                            lineStyle: {
                            width: 0
                            },
                            showSymbol: false,
                            areaStyle: {
                            opacity: 0.8,
                            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            {
                                offset: 0,
                                color: 'rgb(143,188,143)'
                            },
                            {
                                offset: 1,
                                color: 'rgb(143,168,143)'
                            }
                            ])
                            },
                            emphasis: {
                            focus: 'series'
                            },
                            data: this.echartsData.avgAmountList
                            // data: [20, 1818932, 11, 64, 1711990, 40, 25,1818554,36]
                        }
                        ]
                    };
              mychart.setOption(option);
              window.addEventListener("resize", () => {
             	mychart.resize();
            })
          },
        
     
    }
  };
  </script>
  
  <style lang="less" scoped>
    
      .line2{

        width: 100%;
        height: 200px;
        // box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
        border-top: 1px solid whitesmoke;
        // :hover{
        //     box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.3);
        // }
      }
  </style>
  